module.exports = __webpack_public_path__ + "static/media/arrow-down.b53639e6.svg";